'use client';

import React, { useState } from 'react';
import { Sidebar } from './Sidebar';
import { Header } from './Header';
import { AuthBoundary } from '../auth/AuthBoundary';

interface AdminShellProps {
  children: React.ReactNode;
  requiredPermission?: string;
  currentCorrelationId?: string;
}

export const AdminShell: React.FC<AdminShellProps> = ({
  children,
  requiredPermission,
  currentCorrelationId,
}) => {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  return (
    <AuthBoundary requiredPermission={requiredPermission}>
      <div className="flex min-h-screen bg-zinc-950 text-zinc-100 font-sans antialiased">
        <Sidebar isOpen={sidebarOpen} onClose={() => setSidebarOpen(false)} />
        <div className="flex-1 flex flex-col min-w-0">
          <Header
            currentCorrelationId={currentCorrelationId}
            onToggleSidebar={() => setSidebarOpen((prev) => !prev)}
          />
          <main className="flex-1 p-4 sm:p-6 lg:p-8 overflow-x-hidden">
            <div className="max-w-7xl mx-auto w-full">
              {children}
            </div>
          </main>
        </div>
      </div>
    </AuthBoundary>
  );
};
